import { render, staticRenderFns } from "./SundrySuppliersList.vue?vue&type=template&id=67af2cf6&scoped=true&"
import script from "./SundrySuppliersList.vue?vue&type=script&lang=js&"
export * from "./SundrySuppliersList.vue?vue&type=script&lang=js&"
import style0 from "./SundrySuppliersList.vue?vue&type=style&index=0&id=67af2cf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af2cf6",
  null
  
)

export default component.exports